import React, { useState, useCallback, useRef } from "react";

import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import CustomizedTabs from "./CustomizedTabs";
import TextField from "@mui/material/TextField";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { colors, Typography } from "../../Styles/GlobalStyles/Variables";
import { GreyOutlinedButton } from "../Button/CustomButton";
import LoadingButton from "@mui/lab/LoadingButton";
import { IconButton, Box, Divider, Link } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Checkbox from "@mui/material/Checkbox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Iconify from "../Dashboard/Iconify";
import { SkillCenterExcelFile } from "../ExcelFiles/skillcenter"
import FileSaver from "file-saver";
import {
  DropActiveText,
  DropZoneFooter,
  DropZoneText,
  TemplateNameSection,
  TemplateSection,
  TemplateZone,
  dragdropActive,
  dragdropZone,
  errorColor,
  fileNameSection,
  filesUploadedZone,
} from "../../Styles/DragnDrop";
import { BulkUploadBeforeIcon } from "../Icons/FileUploadIcons";
import BulkUploadAfterIcon from "../Icons/BulkUploadAfterIcon.gif";
import Dropzone, { useDropzone } from "react-dropzone";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


export const CreateCentreDialog = ({
  // rename this
  isOpen, //bool
  isLoading, // bool
  onCloseHandler, //fn:null
  nameHolder, //state : string
  nameSetter, //stateSetter : fn -> null
  stateHolder, //state - id : int
  stateSetter, //stateSetter : fn -> null
  skillHolder, //state - id : int
  skillSetter, //skillSetter : fn -> null
  skills,
  states, // state => array of objects
  // onCreateHandler, // fn:null,
  onPrimButtonClickHandler,
  mode,
  form
}) => {
  const [inputValue, setInputValue] = useState("");
  const [ inputSkillValue,setInputSkillValue]= useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [disable, setDisable] = useState(colors.primaryGreen);
  const uploadedItemRef = useRef(null);
  const [value, setValue] = React.useState(0);
  const [bulkFileUpload, setBulkFileUpload] = useState(null);
  const initialBulkFileValues = {
    name: "",
    path: "",
    size: "",
    display: false,
    error: false,
    emptyError: false,
  };
  const [bulkFile, setBulkFile] = useState(initialBulkFileValues);
  const handleDeleteFile = () => {
    setBulkFile(initialBulkFileValues);
    setBulkFileUpload(null);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  function MyDropzone() {
    const onDrop = useCallback((acceptedFiles) => {
      uploadedItemRef?.current?.scrollIntoView({ behavior: "smooth" });
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result;
          console.log(binaryStr, "binarystring");
          console.log(reader, "reader");
          console.log(file, "file");
          if (!file.name.match(/\.(xlsx)$/)) {
            setBulkFile({
              ...bulkFile,
              error: true,
              display: false,
              name: "",
              path: "",
              size: "",
            });
            setBulkFileUpload(null);
            return false;
          } else {
            setBulkFileUpload(file);
            setBulkFile({
              ...bulkFile,
              name: file.name,
              size: file.size,
              display: true,
              error: false,
              emptyError: false,
            });
          }
        };
        reader.readAsArrayBuffer(file);
        console.log(reader.readAsArrayBuffer(file), "as array buffer");
      });
    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
    });

    return (
      <>
        <div
          style={isDragActive ? dragdropActive : dragdropZone}
          {...getRootProps()}
        >
          <div>
            {/* <img src={Folder} alt="folder" width="70px" height="50px" /> */}
          </div>
          <br />
          <input {...getInputProps()} />
          {isDragActive ? (
            <>
              <div style={{ textAlign: "center" }}>
                <img
                  src={BulkUploadAfterIcon}
                  alt="file upload"
                  width={50}
                  height={50}
                />
                <p style={DropActiveText}>
                  {" "}
                  <b>Drop file here...</b>
                </p>
              </div>
            </>
          ) : (
            <>
              <div style={{ textAlign: "center" }}>
                <BulkUploadBeforeIcon />
                <p style={DropZoneText}>Upload the filled-in template here</p>
                <p style={{ fontSize: "10px" }}>
                  Drag and drop, or click to select
                </p>
              </div>
            </>
          )}
        </div>
        <div style={DropZoneFooter}>
          <div>
            <p>File must be in .xlsx</p>
          </div>
          <div>
            <p>Maximum Size: 20MB</p>
          </div>
        </div>
      </>
    );
  }
  
  const handleDownload =(e)=>{
    e.preventDefault();
    // let dataBlob = SkillCenterExcelFile;
    let sliceSize = 1024;
    let byteCharacters = atob(SkillCenterExcelFile)
    let bytelength = byteCharacters.length
    let sliceCount = Math.ceil(bytelength/sliceSize)
    let byteArrays = new Array(sliceCount)
    for(let sliceIndex= 0; sliceIndex<sliceCount; ++sliceIndex){
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin+sliceSize, bytelength)
      let bytes = new Array(end-begin);
      for(var offset = begin, i=0; offset<end; ++i, ++offset){
        bytes[i]= byteCharacters[offset].charCodeAt(0)
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes)
    }
    let blob = new Blob(byteArrays, {type:"application/vnd.ms-excel"})
    FileSaver.saveAs(new Blob([blob],{}), "Skill-Center-Template.xlsx")
  }
  
  return (
    <Dialog
      fullWidth={true}
      fullScreen={fullScreen}
      open={isOpen}
      onClose={onCloseHandler}
      PaperProps={{
        style: { borderRadius: 20, padding: 10 },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "20px",
          fontWeight: 700,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        id="responsive-dialog-title"
      >
        {mode === "Create" ? (
          <>Create New Centre</>
        ) : mode === "View" ? (
          <> View Centre</>
        ) : mode === "Edit" ? (
          <> Edit Centre</>
        ) : null}
        <IconButton onClick={onCloseHandler}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
      <CustomizedTabs
       value={value}
       handleChange={handleChange}
            Item1={
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { p: 2 },
                }}
                noValidate
                autoComplete="off"
              >
        <Grid direction="column" container spacing={3} sx={{ p: 3 }}>
          <Grid item xs>
            <TextField
              variant="outlined"
              color="primary"
              placeholder="Type name here"
              value={nameHolder}
              onChange={nameSetter}
              label="Type name here"
              required
              fullWidth
              readOnly={isLoading || mode === "View"}
              error={form.nameError}
              helperText={form.nameErrorMsg}
            ></TextField>
          </Grid>
          <Grid item xs>
            <Autocomplete
              value={stateHolder}
              onChange={(event, newValue) => {
                // console.log(newValue)  // i guess autocomplete needs the complete object
                stateSetter(newValue); // I cherry pick & forward the state id
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              options={states}
              renderInput={(params) => (
                <TextField {...params} label="Select State"  error={form.stateIdError}
                helperText={form.stateIdErrorMsg} />
              )}
              fullWidth
              getOptionLabel={(option) => option.label}
              readOnly={isLoading || mode === "View"}
            />
          </Grid>
          <Grid item xs>
            <Autocomplete
              value ={skillHolder[0]?.label ===""?[]:skillHolder}
              multiple
              id="checkboxes-skills"
              options={skills}
              disableCloseOnSelect
              getOptionLabel={(option) => option.label?option.label :''}
              // disabled={isLoading || mode === "View"}
              readOnly={isLoading || mode === "View"}
              inputValue={inputSkillValue}
              onInputChange={(event, newInputValue) => {
                setInputSkillValue(newInputValue);
              }}
              onChange={(event, newValue) => {
                if(newValue !== []){
                skillSetter(newValue); // I cherry pick & forward the state id
                }
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.label}
                </li>
              )}
              // style={{ width: 500 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Skillset"
                  placeholder="Skills"
                  error={form.skillIdsError}
                  helperText={form.skillIdsErrorMsg}
                />
              )}
            />
          </Grid>
        </Grid>
        </Box>
      }
            Item2={
              <Box
                component="form"
                sx={{
                  "& > :not(style)": { pt: 2, pb: 0, pl: 2 },
                  fontFamily: Typography.secondaryFont,
                  textTransform: "initial",
                }}
                noValidate
                autoComplete="off"
              >
                {/* <h4>How to Upload</h4>
                <ol style={{ fontSize: "13px", listStylePosition: "inside", }}>
                  <li>Download a template below</li>
                  <li>Add your data to the template file</li>
                  <li>Upload the file for submission. <i style={{color:'#898787'}}>File must be of .xlsx format</i></li>
                </ol>
                <Divider />
                <Box alignItems="center" display="flex" gap="3px">
                  <Iconify icon="ci:download" />
                  <Link
                    color="inherit"
                    sx={{
                      color: colors.lightblue,
                      textDecorationColor: colors.lightBlue,
                    }}
                    component="button"
                    variant="body2"
                    onClick={(e)=>handleDownload(e)}
                  >
                    Download Skill Center Template
                  </Link>
                </Box>
                <Divider/> */}
                 <Box>
                  <div style={{ marginTop: "2px" }}>
                    {bulkFile.error ? (
                      <p style={errorColor}>
                        You can only upload file in .XLSX format{" "}
                      </p>
                    ) : bulkFile.emptyError ? (
                      <p style={errorColor}>Please upload a file to submit</p>
                    ) : (
                      ""
                    )}
                    <MyDropzone />
                  </div>
                  {bulkFile.display ? (
                    <div style={filesUploadedZone} ref={uploadedItemRef}>
                      <div style={fileNameSection}>
                        <div
                          style={{
                            backgroundColor: "#fff",
                            padding: "7px",
                            border: "1.3px solid #e0e0e0",
                            borderRadius: "7pX",
                            width: "fit-content",
                          }}
                        >
                          <Iconify
                            icon="vscode-icons:file-type-excel"
                            style={{ width: "30px", height: "30px" }}
                          />
                        </div>
                        <div>
                          <p style={{ fontWeight: 600 }}>{bulkFile.name}</p>
                          <p style={{ marginTop: "10px", fontWeight: 400 }}>
                            {Math.round(bulkFile.size / 1024)} KB
                          </p>
                        </div>
                      </div>
                      <>
                        <IconButton
                          size="small"
                          sx={{ marginTop: "-15px" }}
                          onClick={handleDeleteFile}
                        >
                          <CloseIcon sx={{ fontSize: "1.2rem" }} />
                        </IconButton>
                      </>
                    </div>
                  ) : (
                    <div style={TemplateZone} ref={uploadedItemRef}>
                      <div>
                        <div style={TemplateNameSection}>
                          <div>
                            {" "}
                            <Iconify
                              icon="vscode-icons:file-type-excel"
                              style={{ width: "30px", height: "30px" }}
                            />
                          </div>

                          <div>
                            <p style={{ fontWeight: 600 }}>
                              Skill Acquisition Center Template Sheet
                            </p>
                          </div>
                        </div>
                        <div>
                          <p
                            style={{
                              marginTop: "10px",
                              fontWeight: 400,
                              color: "9DA3AA",
                              width: "90%",
                            }}
                          >
                            Download the sample template by clicking on the
                            download button. Add your data to the template file
                            and upload the file for submission.{" "}
                          </p>
                        </div>
                      </div>
                      <>
                        <Button
                          onClick={handleDownload}
                          variant="outlined"
                          disableElevation
                          sx={{
                            fontSize: "13px",
                            padding: "10px 25px",
                            background: "#fff",
                            border: "1.3px solid #e0e0e0",
                            borderRadius: "5px",
                            textTransform: "initial",
                            color: "gray",
                            "&:hover": { background: "#fff", color: "#016c34" },
                          }}
                        >
                          Download
                        </Button>
                      </>
                    </div>
                  )}
                </Box>
              </Box>
            }
          />
        </DialogContent>
      <DialogActions sx={{ textTransform: "capitalize", p: 3 }}>
        <GreyOutlinedButton
          sx={{ fontFamily: Typography.secondaryFont, padding: "10px 25px" }}
          autoFocus
          onClick={onCloseHandler}
          disabled={isLoading}
        >
          {mode === "View" ? <>Close</> : <>Cancel</>}
        </GreyOutlinedButton>
        {mode !== "View" && (
          <LoadingButton
            color="primary"
            sx={{
              padding: "10px 25px",
              fontFamily: Typography.secondaryFont,
              color: colors.white,
              backgroundColor: disable,
              textTransform: "inherit",
              // padding: theme.spacing(2),
              "&:hover": {
                backgroundColor: colors.darkGreen,
              },
            }}
            onClick={() => onPrimButtonClickHandler(mode)}
            disabled={isLoading}
            startIcon={isLoading && <CircularProgress size={20} />}
            autoFocus
            // loadingIndicator="Adding..."
          >
            {mode === "Create" ? (
              isLoading === true ? (
                <> Creating... </>
              ) : (
                <> Create Centre </>
              )
            ) : mode === "Edit" ? (
              isLoading === true ? (
                <> Saving...</>
              ) : (
                <> Save Changes </>
              )
            ) : null}
          </LoadingButton>
        )}
      </DialogActions>
    </Dialog>
  );
};

// export const confirmationDialog
